import { render, staticRenderFns } from "./ImageElement.vue?vue&type=template&id=2694e94c&scoped=true&"
import script from "./ImageElement.vue?vue&type=script&lang=js&"
export * from "./ImageElement.vue?vue&type=script&lang=js&"
import style0 from "./ImageElement.vue?vue&type=style&index=0&id=2694e94c&scoped=true&lang=css&"
import style1 from "./ImageElement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694e94c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2694e94c')) {
      api.createRecord('2694e94c', component.options)
    } else {
      api.reload('2694e94c', component.options)
    }
    module.hot.accept("./ImageElement.vue?vue&type=template&id=2694e94c&scoped=true&", function () {
      api.rerender('2694e94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/ImageElement.vue"
export default component.exports